import "@/lib/sentry";
import Sentry from "@/lib/sentry";
import "@/utils/i18n";
import { ThemeProvider } from "@mui/material";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { PostHogProvider } from "posthog-js/react";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import ErrorFallback from "./components/generic/ErrorFallback";
import { PUBLIC_POSTHOG_KEY } from "./config";
import { postHogConfig } from "./config/postHog";
import "./index.css";
import { queryClient } from "./lib/react-query";
import store from "./redux/store";
import CustomRouter from "./router/CustomRouter";
import history from "./router/history";
import theme from "./theme";

// Render the app
ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PostHogProvider apiKey={PUBLIC_POSTHOG_KEY} options={postHogConfig}>
      <ThemeProvider theme={theme}>
        <Sentry.ErrorBoundary fallback={ErrorFallback}>
          <Provider store={store}>
            <QueryClientProvider client={queryClient}>
              <CustomRouter history={history}>
                <App />
              </CustomRouter>
              <ReactQueryDevtools />
            </QueryClientProvider>
          </Provider>
        </Sentry.ErrorBoundary>
      </ThemeProvider>
    </PostHogProvider>
  </StrictMode>
);
